import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
// 获取列表内容封装在mixins内部  getTableData方法 初始化已封装完成

import { getAuthorityList, deleteAuthority, createAuthority, updateAuthority, copyAuthority } from "@/api/authority";
import Menus from "@/view/superAdmin/authority/components/menus";
// import Apis from "@/view/superAdmin/authority/components/apis";
// import Datas from "@/view/superAdmin/authority/components/datas";
// import Games from "@/view/superAdmin/authority/components/games";
import Channels from "@/view/superAdmin/authority/components/channel";
import infoList from "@/mixins/infoList";
export default {
  name: "Authority",
  mixins: [infoList],
  components: {
    Menus: Menus,
    Channels: Channels
  },
  data: function data() {
    var mustUint = function mustUint(rule, value, callback) {
      if (!/^[0-9]*[1-9][0-9]*$/.test(value)) {
        return callback(new Error("请输入正整数"));
      }
      return callback();
    };
    return {
      AuthorityOption: [{
        authorityId: "0",
        authorityName: "根角色"
      }],
      listApi: getAuthorityList,
      drawer: false,
      dialogType: "add",
      activeRow: {},
      activeUserId: 0,
      dialogTitle: "新增角色",
      dialogFormVisible: false,
      apiDialogFlag: false,
      copyForm: {},
      form: {
        authorityId: "",
        authorityName: "",
        parentId: "0"
      },
      rules: {
        authorityId: [{
          required: true,
          message: "请输入角色ID",
          trigger: "blur"
        }, {
          validator: mustUint,
          trigger: "blur"
        }],
        authorityName: [{
          required: true,
          message: "请输入角色名",
          trigger: "blur"
        }],
        parentId: [{
          required: true,
          message: "请选择请求方式",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    autoEnter: function autoEnter(activeName, oldActiveName) {
      // const paneArr = ["menus", "apis", "datas", "games", "apps"];
      var paneArr = ["menus", "channels"];
      if (oldActiveName) {
        var component = this.$refs[paneArr[oldActiveName]];
        if (component.needConfirm) {
          component.enterAndNext();
          component.needConfirm = false;
        }
      }
    },
    // 拷贝角色
    copyAuthority: function copyAuthority(row) {
      this.setOptions();
      this.dialogTitle = "拷贝角色";
      this.dialogType = "copy";
      for (var k in this.form) {
        this.form[k] = row[k];
      }
      this.copyForm = row;
      this.dialogFormVisible = true;
    },
    opdendrawer: function opdendrawer(row) {
      this.drawer = true;
      this.activeRow = row;
    },
    // 删除角色
    deleteAuth: function deleteAuth(row) {
      var _this = this;
      this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return deleteAuthority({
                authorityId: row.authorityId
              });
            case 2:
              res = _context.sent;
              if (res.code == 0) {
                _this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                if (_this.tableData.length == 1) {
                  _this.page--;
                }
                _this.getTableData();
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))).catch(function () {
        _this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    // 初始化表单
    initForm: function initForm() {
      if (this.$refs.authorityForm) {
        this.$refs.authorityForm.resetFields();
      }
      this.form = {
        authorityId: "",
        authorityName: "",
        parentId: "0"
      };
    },
    // 关闭窗口
    closeDialog: function closeDialog() {
      this.initForm();
      this.dialogFormVisible = false;
      this.apiDialogFlag = false;
    },
    // 确定弹窗
    enterDialog: function enterDialog() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(_this2.form.authorityId == "0")) {
                _context3.next = 3;
                break;
              }
              _this2.$message({
                type: "error",
                message: "角色id不能为0"
              });
              return _context3.abrupt("return", false);
            case 3:
              _this2.$refs.authorityForm.validate( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(valid) {
                  var res, _res, data, _res2;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!valid) {
                          _context2.next = 26;
                          break;
                        }
                        _context2.t0 = _this2.dialogType;
                        _context2.next = _context2.t0 === "add" ? 4 : _context2.t0 === "edit" ? 9 : _context2.t0 === "copy" ? 14 : 24;
                        break;
                      case 4:
                        _context2.next = 6;
                        return createAuthority(_this2.form);
                      case 6:
                        res = _context2.sent;
                        if (res.code == 0) {
                          _this2.$message({
                            type: "success",
                            message: "添加成功!"
                          });
                          _this2.getTableData();
                          _this2.closeDialog();
                        }
                        return _context2.abrupt("break", 24);
                      case 9:
                        _context2.next = 11;
                        return updateAuthority(_this2.form);
                      case 11:
                        _res = _context2.sent;
                        if (_res.code == 0) {
                          _this2.$message({
                            type: "success",
                            message: "添加成功!"
                          });
                          _this2.getTableData();
                          _this2.closeDialog();
                        }
                        return _context2.abrupt("break", 24);
                      case 14:
                        data = {
                          authority: {
                            authorityId: "string",
                            authorityName: "string",
                            datauthorityId: [],
                            parentId: "string"
                          },
                          oldAuthorityId: 0
                        };
                        data.authority.authorityId = _this2.form.authorityId;
                        data.authority.authorityName = _this2.form.authorityName;
                        data.authority.parentId = _this2.form.parentId;
                        data.authority.dataAuthorityId = _this2.copyForm.dataAuthorityId;
                        data.oldAuthorityId = _this2.copyForm.authorityId;
                        _context2.next = 22;
                        return copyAuthority(data);
                      case 22:
                        _res2 = _context2.sent;
                        if (_res2.code == 0) {
                          _this2.$message({
                            type: "success",
                            message: "复制成功！"
                          });
                          _this2.getTableData();
                        }
                      case 24:
                        _this2.initForm();
                        _this2.dialogFormVisible = false;
                      case 26:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    setOptions: function setOptions() {
      this.AuthorityOption = [{
        authorityId: "0",
        authorityName: "根角色"
      }];
      this.setAuthorityOptions(this.tableData, this.AuthorityOption, false);
    },
    setAuthorityOptions: function setAuthorityOptions(AuthorityData, optionsData, disabled) {
      var _this3 = this;
      this.form.authorityId = String(this.form.authorityId);
      AuthorityData && AuthorityData.map(function (item) {
        if (item.children && item.children.length) {
          var option = {
            authorityId: item.authorityId,
            authorityName: item.authorityName,
            disabled: disabled || item.authorityId == _this3.form.authorityId,
            children: []
          };
          _this3.setAuthorityOptions(item.children, option.children, disabled || item.authorityId == _this3.form.authorityId);
          optionsData.push(option);
        } else {
          var _option = {
            authorityId: item.authorityId,
            authorityName: item.authorityName,
            disabled: disabled || item.authorityId == _this3.form.authorityId
          };
          optionsData.push(_option);
        }
      });
    },
    // 增加角色
    addAuthority: function addAuthority(parentId) {
      this.initForm();
      this.dialogTitle = "新增角色";
      this.dialogType = "add";
      this.form.parentId = parentId;
      this.setOptions();
      this.dialogFormVisible = true;
    },
    // 编辑角色
    editAuthority: function editAuthority(row) {
      this.setOptions();
      this.dialogTitle = "编辑角色";
      this.dialogType = "edit";
      for (var key in this.form) {
        this.form[key] = row[key];
      }
      this.setOptions();
      this.dialogFormVisible = true;
    }
  },
  created: function created() {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _this4.pageSize = 999;
            _context4.next = 3;
            return _this4.getTableData();
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  }
};